import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import EllipsisButton from './EllipsisButton';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';

const EllipsisDropdown = ({
  listItems,
  className,
  pullRight,
  attributes,
  buttonClassName
}) => (
  <Dropdown componentClass="div" className={classnames('ellipsis-dropdown', className)} pullRight={pullRight}>
    <EllipsisButton buttonClassName={buttonClassName} bsRole="toggle" />
    <Dropdown.Menu
      bsRole="menu"
      className="ellipsis-dropdown-menu"
      { ...attributes }
    >
      {
        listItems.map((item) => (
          <MenuItem
            href={item.href}
            onClick={item.onClick}
            className={item.className}
            data-testing-id={item.testingId}
          >
            {item.title}
          </MenuItem>
        ))
      }
    </Dropdown.Menu>
  </Dropdown>
);

EllipsisDropdown.propTypes = {
  listItems: PropTypes.array,
  className: PropTypes.string,
  pullRight: PropTypes.bool,
  attributes: PropTypes.object,
  buttonClassName: PropTypes.string
};

export default EllipsisDropdown;
